import React, { useEffect, useState } from "react";
import CustomDataTableBasic from "../../../partials/content/CustomDataTableBasic";
import DialogLayout from "../../../partials/content/DialogLayout";
import CustomFileViewer from "../../../partials/content/CustomFileViewer";
import { DialogActions } from "@material-ui/core";
import { DropzoneAreaBase } from "material-ui-dropzone";
import {
  getAttachments,
  uploadAttachments,
  deleteAttachment,
} from "../../../services/commons";
import { FileIcon, defaultStyles } from "react-file-icon";
import { formatDate } from "../../../utils/utils";
import { Formik } from "formik";
import * as yup from "yup";
import { onPreventEnterSubmitting } from "../../../utils/utils";
import Swal from "sweetalert2";
import ResponsiveEllipsis from "../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../partials/content/BootstrapTooltip";
import Illustration from "../../../partials/content/Illustration";
import { getFileExtension } from "../../../utils/utils";
import { useGlobalData } from "../../../../provider/GlobalDataProvider";
function Attachments({ docType = "", docID = 0 }) {
  const { reload } = useGlobalData();
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [openFileViewer, setOpenFileViewer] = useState(false);
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [filePath, setFilePath] = useState("");

  useEffect(() => {
    getAttachmentsData(docType, docID);
  }, [docType, docID, reload]);

  const handlePreviewIcon = (fileObject, classes) => {
    const { name } = fileObject.file;
    return (
      <div
        style={{
          WebkitFontSmoothing: "antialiased",
          width: "40px",
          margin: "auto",
        }}
      >
        <FileIcon
          extension={getFileExtension(name)}
          {...defaultStyles[`${getFileExtension(name)}`]}
          labelUppercase
        />
      </div>
    );
  };

  let attachmentData = {
    ID: 0,
  };

  const attachmentFormSchema = yup.object().shape({
    ID: yup.number(),
  });

  return (
    <React.Fragment>
      {attachments.length ? (
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              className="btn btn-primary btn-md btn-pill btn-bold"
              onClick={() => {
                setOpenUploadFile(true);
              }}
            >
              <i className="fas fa-upload"></i>
              Upload Files
            </button>
          </div>
        </div>
      ) : null}
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {attachments.length ? (
            <CustomDataTableBasic
              data={attachments}
              onRefreshData={() => {
                getAttachmentsData(docType, docID);
              }}
              onSelectedData={(rowData, originalEvent) => {
                let cellIndex = find_cellIndex(originalEvent.target);
                if (cellIndex !== 4) {
                  setFileName(rowData.fileName);
                  setFileType(rowData.fileType);
                  setFilePath(rowData.filePath);
                  setOpenFileViewer(true);
                }
              }}
              columns={[
                {
                  header: "FileType",
                  field: "fileType",
                  body: (rowData) => (
                    <React.Fragment>
                      <div
                        style={{
                          WebkitFontSmoothing: "antialiased",
                          width: "40px",
                        }}
                      >
                        <FileIcon
                          extension={rowData.fileType}
                          {...defaultStyles[`${rowData.fileType}`]}
                          labelUppercase
                        />
                      </div>
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "FileName",
                  field: "fileName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.fileName} maxLine="2" />
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Uploaded By",
                  field: "uploadedByUser.fullName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.uploadedByUser.fullName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Uploaded At",
                  field: "CreatedAt",
                  body: (rowData) => (
                    <React.Fragment>
                      {formatDate(rowData.CreatedAt)}
                    </React.Fragment>
                  ),
                  sortable: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      <a
                        href={rowData.filePath}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                      >
                        <BootstrapTooltip title="Download Attachment">
                          <button
                            type="button"
                            onClick={() => {}}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-cloud-download-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      </a>
                      <BootstrapTooltip title="Delete Attachment">
                        <button
                          type="button"
                          onClick={() => deleteAttachmentData(rowData.ID)}
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          ) : (
            <React.Fragment>
              <Illustration
                imageSource="INVIFO Setup.png"
                guidance="Hooray! You're ready to have your first Attachment for this document!"
                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                size="md"
              ></Illustration>
              <div className="text-center py-3">
                <button
                  type="button"
                  className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                  onClick={() => {
                    setOpenUploadFile(true);
                  }}
                >
                  <i className="fas fa-upload"></i>
                  Upload Files
                </button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      <DialogLayout
        open={openUploadFile}
        title="Attachment Upload Form"
        onCloseDialog={() => {
          setOpenUploadFile(false);
        }}
        maxWIdth="md"
      >
        <Formik
          initialValues={attachmentData}
          enableReinitialize={true}
          validationSchema={attachmentFormSchema}
          onSubmit={async (values, { setStatus, setSubmitting }) => {
            if (files.length > 0) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              })
                .fire({
                  title: "Are you sure want to upload this Attachment ?",
                  text: "Please note that you are responsible for this action",
                  icon: "question",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, upload it`,
                  cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    const filesData = new FormData();
                    for (const file of files) {
                      filesData.append("files[]", file.file);
                    }
                    filesData.append("docID", docID);
                    filesData.append("docType", docType);
                    setFiles([]);
                    setOpenUploadFile(false);
                    uploadAttachments(filesData).then((response) => {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Uploaded",
                        html: response.data.message,
                        icon: "success",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                      setFiles([]);
                      setOpenUploadFile(false);
                      getAttachmentsData(docType, docID);
                    });
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Cancelled",
                      text: "No change has been made",
                      icon: "info",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  }
                });
            } else {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text: "Please upload a file",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form
              noValidate={true}
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              <DropzoneAreaBase
                fileObjects={files}
                maxFileSize={10000000}
                filesLimit={9}
                getPreviewIcon={handlePreviewIcon}
                onAdd={(newFile) => {
                  setFiles([].concat(files, newFile));
                }}
                onDelete={(deleteFile) => {
                  const fileList = [...files];
                  fileList.map((file, indexFile) => {
                    if (file.data === deleteFile.data) {
                      if (indexFile !== -1) {
                        fileList.splice(indexFile, 1);
                      }
                    }
                  });
                  setFiles(fileList);
                }}
                showPreviewsInDropzone={true}
                showFileNames={true}
                dropzoneText="Drag and drop a file here or click"
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenUploadFile(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success btn-md btn-pill btn-bold"
                  disabled={isSubmitting}
                >
                  <i className="fas fa-save"></i>
                  Save
                </button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogLayout>
      <DialogLayout
        open={openFileViewer}
        title={"File Preview: " + `${fileName}`}
        onCloseDialog={() => {
          setOpenFileViewer(false);
        }}
        maxWIdth="lg"
      >
        <CustomFileViewer filePath={filePath} fileType={fileType} />
        <DialogActions>
          <button
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenFileViewer(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Cancel
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getAttachmentsData(docType, docID) {
    const response = await getAttachments(docType, docID);
    const { data } = response.data;
    setAttachments(data.attachments);
  }

  async function deleteAttachmentData(attachmentID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Attachment ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteAttachment(attachmentID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getAttachmentsData(docType, docID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function find_cellIndex(target) {
    if (target.cellIndex !== undefined) return target.cellIndex;
    if (target.parentElement) return find_cellIndex(target.parentElement);
  }
}

export default Attachments;
